import { Edit, Trash2 } from 'lucide-react';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import type { ContextMenuItem } from './ContextMenu';

/** Class on wrappers around table edit/delete icon buttons: visible from `sm` up. */
export const TABLE_QUICK_ACTION_CLASS = 'hidden sm:contents';

/** Matches Tailwind `sm` — inline edit/delete visible at this breakpoint and up. */
export const TABLE_QUICK_EDIT_DELETE_MEDIA = '(min-width: 640px)';

/** True when edit/delete quick-action icons are shown (omit them from ⋯ menu). */
export function useQuickEditDeleteVisible(): boolean {
  return useMediaQuery(TABLE_QUICK_EDIT_DELETE_MEDIA);
}

/** Append edit/delete to ⋯ menu unless the same actions are shown inline. */
export function appendEditDeleteMenuItems(params: {
  items: ContextMenuItem[];
  t: (key: string) => string;
  onEdit?: () => void;
  onDelete?: () => void;
  omitFromMenu?: boolean;
}): void {
  const { items, t, onEdit, onDelete, omitFromMenu = false } = params;
  if (omitFromMenu) return;
  if (onEdit) {
    items.push({
      label: t('common.edit'),
      onClick: onEdit,
      icon: Edit,
    });
  }
  if (onDelete) {
    items.push({
      label: t('common.delete'),
      onClick: onDelete,
      icon: Trash2,
    });
  }
}
